import React from 'react';
import { FormFieldValue } from '../types';
import { TextFormFieldValidator } from './TextFormFieldValidator';

export class NumberFormFieldValidator extends TextFormFieldValidator {
  static ONLY_DIGITS_REGEX_PATTERN = '\\D';

  static checkPressedKeySequenceIsValid(event: React.KeyboardEvent<HTMLInputElement>) {
    const key = event.charCode || event.keyCode || 0;
    const controlDown = event.ctrlKey || event.metaKey;
    const shiftDown = event.shiftKey;

    // allow backspace, tab, delete, enter, arrows, numbers and keypad numbers ONLY
    // home, end, period, and numpad decimal
    // ctrl+a, ctrl+c, ctrl+v, ctrl+x
    const result =
      !shiftDown &&
      (key === 8 ||
        key === 9 ||
        key === 13 ||
        key === 46 ||
        // key === 110 || key === 190 || // exclude period and numpad decimal
        (key >= 35 && key <= 40) ||
        (!shiftDown && key >= 48 && key <= 57) ||
        (key >= 96 && key <= 105) ||
        (controlDown && key === 65) ||
        (controlDown && key === 67) ||
        (controlDown && key === 86) ||
        (controlDown && key === 88));

    if (!result) {
      event.preventDefault();
    }
  }

  protected isValid(value: FormFieldValue) {
    const regex = new RegExp(NumberFormFieldValidator.ONLY_DIGITS_REGEX_PATTERN, 'g');
    return this.isEmpty(value)
      ? this.requiredCheck(value)
      : this.requiredCheck(value) && this.lengthCheck(value) && !regex.test(value as string);
  }
}
